module.exports = __webpack_public_path__ + "img/303.6dba3b08.png";